import React from 'react';
import {MasterLayout} from 'layout';
import {TongHopKetQua} from 'modules/thong-ke-bao-cao';

class TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='XU_PHAT_KIEM_TRA_CHUYEN_NGANH'/>
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage;


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage.jsx